export class AssetInQuestionResponse {
    assetInQuestionResponseId: number;
    baseAssetId: number;
    linkedQuestionResponseId: number;
    assetInQuestionResponseIndex: number;
    sceneAssetRelationId: number;
}